import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import type { Student } from "@/types/student";
import { LEAD_SOURCE_LABELS } from "@/types/enums";
import { formatDate } from "@/utils/format";

function Field({ label, value }: { label: string; value?: string | number | null }) {
  return (
    <Stack spacing={0.25}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1">{value ?? "—"}</Typography>
    </Stack>
  );
}

export function StudentProfileTab({ student }: { student: Student }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="ФИО" value={student.fullName} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="Телефон" value={student.phone} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="Телефон родителя" value={student.parentPhone} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="Год рождения" value={student.birthYear} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="Филиал" value={student.branchName} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="Источник" value={LEAD_SOURCE_LABELS[student.source]} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field label="Дата регистрации" value={formatDate(student.createdAt)} />
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ my: 1 }} />
        <Field label="Заметка" value={student.note} />
      </Grid>
    </Grid>
  );
}
